import React from 'react';
import {Helmet} from "react-helmet";
import HeroSection2 from "../sectionBlocks/HeroSection2";
import NFTMarketPlace from '../sectionBlocks/NFTMarket';
// import RoadMap from '../sectionBlocks/RoadMap';
// import NFTMarketPlace from "../sectionBlocks/NFTMarket";
import Footer from '../sectionBlocks/Footer';

const ThreeDAnimation = ({loading, data, error, localData}) => {
  return (
    <>
      <Helmet>
        <title>3D Animations · PopBeLLy</title>
      </Helmet>
      <HeroSection2 categoryName={"3d AnimATeD PeoPle"}/>
      <NFTMarketPlace 
        displayCollectionName = {`dn`} 
        collectionName = {``} 
        displayPagination = {``} 
        displayLink = {`dn`} 
        linkAddress = {``} 
        linkTitle = {``} 
        fetchingCardsRule = {({meta,bestSellOrder}) => bestSellOrder.makePrice > 30 && meta.attributes[0].value === "People"} 
        sliceStart = {0} 
        loading = {loading} 
        data = {data} 
        error = {error} 
        localData = {localData}
      />
      <Footer/>
    </>
  );
};

export default ThreeDAnimation;